// Price change on quantity change

// function getSelectedPriceAndQuantity(container) {
//   const quantityInput = container.querySelector('.quantity__input');
//   if (!quantityInput) return null;

//   let unitPrice = 0;

//   // Check for subscription price
// //   const checkedRadio = container.querySelector('.shopify_subscriptions_app_block_label input[type=radio]:checked');
// //   if (checkedRadio) {
// //     const priceElement = checkedRadio.closest('.shopify_subscriptions_app_block_label')?.querySelector('.block_product-grid_subscribe-price');
// //     if (priceElement) {
// //       const rawPrice = priceElement.getAttribute('data-price') || '0';
// //       unitPrice = parseFloat(rawPrice.replace(/[^0-9.]/g, '')) || 0;
// //     }
// //   }

//   // Fallback: Use regular product price
//   if (!unitPrice) {
//     const priceElement = container.querySelector('.price__regular .price-item--regular');
//     if (!priceElement) return null;
//     const rawPrice = priceElement.textContent || '0';
//     unitPrice = parseFloat(rawPrice.replace(/[^0-9.]/g, '')) || 0;
//   }

//   const quantity = parseInt(quantityInput.value, 10);
//   if (isNaN(unitPrice) || isNaN(quantity)) return null;

//   const total = unitPrice * quantity;
//   const formattedPrice = window?.Shopify?.formatMoney
//     ? Shopify.formatMoney(total * 100)
//     : `$${total.toFixed(2)}`;

//   return {
//     formattedPrice,
//     unitPrice,
//     quantity
//   };
// }


// function updateDisplayPrices(container) {
//   const result = getSelectedPriceAndQuantity(container);
//   if (!result) return;

//   const { formattedPrice } = result;

//   // Update Add to Cart button price
//   const addToCartSpan = container.querySelector('.product-form__submit .add-to-cart-price');
//   if (addToCartSpan) {
//     addToCartSpan.textContent = `Add To Cart - ${formattedPrice}`;
//   }
// }

// Add to cart button price update on radio change
// document.querySelectorAll('.shopify_subscriptions_app_block_label input[type=radio]').forEach(radio => {
//   radio.addEventListener('change', function () {
//     const container = radio.closest('.product');
//     if (!container) return;
//     updateDisplayPrices(container);
//   });
// });

// Add to cart button price update on quantity change
function initQuantityListener() {
  document.querySelectorAll('.quantity__input').forEach(input => {
    input.addEventListener('change', () => {
      const container = input.closest('.product');
      if (!container) return;
      updateDisplayPrices(container);
    });
  });
}

initQuantityListener();

// ========================= header cart number update ===========================
// Function to update all cart count elements
function updateCartCount(count) {
  // Update mobile cart count
  const mobileCartCount = document.querySelectorAll('.mobile_cart_count');
  mobileCartCount.forEach(el => el.textContent = count);

  // Update cart count bubble
  const cartBubble = document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]');
  cartBubble.forEach(el => el.textContent = `(${count})`);
}

// Listen for Shopify cart updates (AJAX)
document.addEventListener('DOMContentLoaded', function() {
  // Initial update on page load
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => updateCartCount(cart.item_count));

  // Listen to AJAX cart updates (for Shopify AJAX API)
  document.body.addEventListener('cart:updated', function(event) {
    if(event.detail && event.detail.cart) {
      updateCartCount(event.detail.cart.item_count);
    }
  });

  // Optional: If your theme triggers 'cart:updated' event on add-to-cart
  // Otherwise, you can manually call updateCartCount after add-to-cart AJAX request
});



// Price Change on variant click

// document.addEventListener("DOMContentLoaded", function () {
//   document.querySelectorAll(".product-form__input--swatch input[type='radio']").forEach(radio => {
//     radio.addEventListener("change", function () {
//       const productCard = this.closest(".card-wrapper");
//       if (!productCard) return;

//       const variantDataEl = productCard.querySelector(".variant-data");
//       if (!variantDataEl) return;

//       const variants = JSON.parse(variantDataEl.textContent);
//       const variantId = this.dataset.variantId ? parseInt(this.dataset.variantId) : parseInt(this.value);
//       const selectedVariant = variants.find(v => v.id === variantId);
//       if (!selectedVariant) return;

//       // Update image
//       const imgEl = productCard.querySelector(".card__media img");
//       if (imgEl && selectedVariant.featured_image) {
//         imgEl.src = selectedVariant.featured_image.src;
//         imgEl.srcset = selectedVariant.featured_image.src;
//         imgEl.alt = selectedVariant.featured_image.alt || "";
//       }

//       // Update price (with browser fallback)
//       const priceEl = productCard.querySelector(".price__sale .price-item--sale");
//       if (priceEl) {
//         priceEl.textContent = (selectedVariant.price / 100).toLocaleString(undefined, {
//           style: "currency",
//           currency: "USD",
//         });
//       }

//       // Update compare price (optional)
//       const compareEl = productCard.querySelector(".price__sale .price-item--regular");
//       if (compareEl) {
//         if (selectedVariant.compare_at_price > selectedVariant.price) {
//           compareEl.textContent = (selectedVariant.compare_at_price / 100).toLocaleString(undefined, {
//             style: "currency",
//             currency: "USD",
//           });
//           compareEl.style.display = "inline-block";
//         } else {
//           compareEl.style.display = "none";
//         }
//       }
//     });
//   });
// });

// Product info Scroll position 100px from top
document.querySelectorAll('.breadcrumb-a').forEach(link => {
  link.addEventListener('click', function(e) {
    e.preventDefault();
    const target = document.querySelector(this.getAttribute('href'));
    const headerOffset = 100; // sticky header height
    const elementPosition = target.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  });
});

// ==========================  Blog Search Filter start =========================== //
function filterApply(value, div) {
let title = document.querySelectorAll(".blog-post-title");
let searchValue = value.toLowerCase();
    title.forEach((e) => {
        let dataTitle = e.getAttribute("data-post-title").toLowerCase();
        let titleParentDiv = e.closest(".filter_box");
        if (titleParentDiv) {
        if (dataTitle.indexOf(searchValue) > -1) {
            titleParentDiv.classList.add("active");
        } else {
            titleParentDiv.classList.remove("active");
        }
        }
    });
}
document.addEventListener("DOMContentLoaded", function () {
    let blockFilter = document.querySelector('[id^="filter-"]');
    if (blockFilter) {
        blockFilter.addEventListener("keyup", function () {
        filterApply(this.value, this.closest(".page-width"));
        });
    }
});
// ==========================  Blog Search Filter End =========================== //